import NavigationBar from './NavigationBar';
import './style/navigation-bar.less';

export { default as NavigationBarBackBtn } from './components/back-btn';

export default NavigationBar;
